export default __webpack_public_path__ + "app/images/e448b5ebaeb760f63cbcd0be519c46a3.png";